export default {
  ressubmit_review: "إرسال التقييم",
  resreview_products: "تقييم المنتجات",
  resselect_product: "اختر المنتج",
  resselect_product_placeholder: "-- اختر المنتج --",
  resrating: "التقييم",
  resreview_text: "نص التقييم",
  reswrite_feedback: "اكتب ملاحظاتك...",
  resupload_photo: "تحميل صورة",
  resupload: "تحميل",
  resmy_reviews: "تقييماتي",
  resloading_reviews: "جاري تحميل التقييمات...",
  resproduct: "المنتج",
  resreview: "التعليق",
  resphoto: "الصورة",
  resclose: "إغلاق",
  resselect_product_error: "يرجى اختيار منتج",
  resload_items_error: "فشل تحميل عناصر الطلب",
  ressuccess_review: "تم إرسال التقييم بنجاح!",
  resreview_failed: "فشل إرسال التقييم",

  ResreviewsRatings: "التقييمات والمراجعات",
  ResreviewsSubtitle: "عرض الطلبات المسلمة وإرسال المراجعات",
  ResreviewLoadFailed: "فشل تحميل الطلبات المسلمة",
  ResorderId: "رقم الطلب",
  Ressupplier: "المورد",
  Resaction: "الإجراء",
  ResnoDeliveredOrders: "لا توجد طلبات مسلمة",
};